export default "__VITE_ASSET__d4bb81c1__"